import { render, staticRenderFns } from "./actionIndex.vue?vue&type=template&id=0f4ac74b&scoped=true"
import script from "./actionIndex.vue?vue&type=script&lang=js"
export * from "./actionIndex.vue?vue&type=script&lang=js"
import style0 from "./actionIndex.vue?vue&type=style&index=0&id=0f4ac74b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4ac74b",
  null
  
)

export default component.exports